import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { baseProductSpecs, baseUnitState, calculationSpecs, productMeasurements } from '@state';
import { getProductDimensions } from '@hooks';
import { ResponsiveImage } from '@src/components/parts/media/ResponsiveImage';
import { useMount } from 'ahooks';

const ProductSchematics = ({ image, handle }) => {
  const measurements = useRecoilValue(productMeasurements);
  const [loading, setLoading] = useState(false);
  const [productDimensions, setProductDimensions] = useState(null);
  const productSpecs = useRecoilValue(baseProductSpecs);
  const baseUnit = useRecoilValue(baseUnitState);
  let unitSuffix = baseUnit === 'metric' ? 'mm' : '"';

  useEffect(() => {
    if (measurements && productSpecs) {
      setLoading(true);
      let getData = async () => {
        let dimensionsData = await getProductDimensions({ measurements, handle, baseUnit, productSpecs });
        setProductDimensions(dimensionsData);
        setTimeout(() => {
          setLoading(false);
        }, 200);
      };
      getData();
    }
  }, [measurements, productSpecs]);

  if (!productDimensions) {
    return null;
  }

  if (!measurements?.length || !productDimensions) {
    return (
      <div className="diagram">
        <div className="diagram_wrapper">
          <ResponsiveImage image={image}></ResponsiveImage>
        </div>
      </div>
    );
  }

  let columns = productDimensions.gridCols.map((item) => `${item * 100}%`);
  let rows = productDimensions.gridRows.map((item) => `${item * 100}%`);
  const subGridStyles = {
    gridTemplateColumns: `${columns.join(' ')}`,
    gridTemplateRows: `${rows.join(' ')}`,
    bottom: `${productDimensions.paddingBottom}%`,
  };

  return (
    <div className="diagram">
      <div className="diagram_wrapper">
        <ResponsiveImage image={image}></ResponsiveImage>
        <div className="gridReference" style={subGridStyles}>
          {productDimensions.cells.map((cell, index) => {
            let cellStyles = {
              gridColumn: `auto / span ${cell.spanX}`,
              gridRow: `auto / span ${cell.spanY || 1}`,
            };
            return (
              <span className="gridReference__cell" key={`cell-${index}`} style={cellStyles}>
                {Boolean(cell.width) && (
                  <>
                    {cell.width}
                    {unitSuffix} W x {cell.length}
                    {unitSuffix} L
                  </>
                )}
              </span>
            );
          })}
          <div className="diagram_legend width">
            <span>width</span>
          </div>
          <div className="diagram_legend height">
            <span>length</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSchematics;
